import { render, staticRenderFns } from "./UserDetailNav.vue?vue&type=template&id=9649f830&scoped=true&"
import script from "./UserDetailNav.vue?vue&type=script&lang=ts&"
export * from "./UserDetailNav.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailNav.vue?vue&type=style&index=0&id=9649f830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9649f830",
  null
  
)

export default component.exports